// Small pub/sub so the Menu's New Game button (in ui.ts) can tell the running
// GameScene to reset world position, without either module needing a direct
// reference to the other -- same pattern as settings.ts's onSpriteIdChange.

const listeners: Array<() => void> = [];

export function onNewGame(listener: () => void): void {
  listeners.push(listener);
}

export function triggerNewGame(): void {
  listeners.forEach((listener) => listener());
}
